<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 工单记录
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.work_sn" placeholder="工单号"   style="width:200px;"></el-input>
          <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleFilter"
          >搜索</el-button>

        </div>

        <el-table border v-loading="listLoading"  min-height="200"  max-height="1000"  :data="tableData" style="width: 100%">
          <el-table-column prop="work_date" label="时间"/>
          <el-table-column prop="work_sn" label="工单号"/>
          <el-table-column prop="operation" label="操作"/>
          <el-table-column prop="content" label="内容"/>
          <el-table-column
                  prop="files"
                  header-align="center"
                  align="center"
                  width="150px"
                  label="图片">
            <template slot-scope="scope">
              <el-popover
                      placement="right"
                      title=""
                      trigger="hover">
                <img v-for="item in scope.row.files" :src="item" />
                <img slot="reference" v-for="item in scope.row.files" :src="item" :alt="item" style="max-height: 50px;max-width: 130px">
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="deal_user" label="操作人"/>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleList"
        />

      </div>
    </div>
  </div>
</template>

<script>
import {
  handleListApi,
} from "@/api/work_log.js";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  name: "work_log",
  data() {
    return {
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10,
        work_sn:undefined
      },
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      passwordVisible: false,
      formData: {
        work_date: "",
        work_sn: "",
        operation: "",
        content: "",
        deal_user: "",
        status: "",
        files: []
      },
    };
  },
  created() {
    this.listQuery.work_sn = this.$route.params.work_sn;
    this.handleList(this.listQuery);
  },
  methods: {
    handleList() {
      this.listLoading = true;
      handleListApi(this.listQuery)
        .then(response => {
          const data = response.data.data;
          this.tableData = data;
          this.total = response.data.total;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch(error => {
          this.listLoading = false;
          console.log(error);
        });
    },

    handleFilter() {
      this.handleList(this.listQuery);
    },

    handleDownload() {
      console.log(13);
    }
  }
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
